import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import {
  IEditEventPayload,
  IParamsGetScheduleEvent,
  IPayloadDeleteEvents,
  IResponseGetScheduleEvent,
  IResponseGetScheduleDayEvent,
} from '~/utils/interface/schedule';

const scheduleEventApi = {
  getEvents(params: IParamsGetScheduleEvent) {
    const url = `api/admin/events`;
    return axiosClient.get<IApiBaseResponse<IResponseGetScheduleEvent>>(url, { params });
  },
  getDayEvents(params: IParamsGetScheduleEvent) {
    const url = `api/admin/events/day-view`;
    return axiosClient.get<IApiBaseResponse<IResponseGetScheduleDayEvent>>(url, { params });
  },
  addEvent(newEventPayload: IEditEventPayload) {
    const url = `api/admin/events`;
    return axiosClient.post<IApiBaseResponse<any>>(url, newEventPayload);
  },
  getEvent(id: string) {
    const url = `api/admin/events/${id}`;
    return axiosClient.get<IApiBaseResponse<IEditEventPayload>>(url);
  },
  updateEvent(id: string, data: IEditEventPayload) {
    const url = `api/admin/events/${id}`;
    return axiosClient.put<IApiBaseResponse<any>>(url, data);
  },
  deleteEvent(data: IPayloadDeleteEvents) {
    const url = `api/admin/events`;
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
};

export default scheduleEventApi;
